import http from './http';

export async function importStudentsExcel(file) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await http.post('/admin/student-import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}
